import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.33, 1, 0.68, 1];

const ContactSection = ({ onContact }) => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative overflow-hidden border-t border-white/10 bg-abyss py-32 md:py-48"
    >
      <div className="absolute inset-0 bg-blueprint opacity-40" />
      <div className="pointer-events-none absolute bottom-0 left-1/2 h-[50vh] w-[80vw] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse_at_bottom,rgba(0,255,148,0.05),transparent_65%)]" />

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-mono text-xs uppercase tracking-[0.35em] text-neon md:text-sm"
          data-testid="contact-overline"
        >
          // Transmission Channel Open
        </motion.p>

        <div className="mt-8 overflow-hidden">
          <motion.h2
            initial={{ y: "60%", opacity: 0 }}
            whileInView={{ y: "0%", opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: EASE }}
            className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tighter sm:text-6xl md:text-8xl"
            data-testid="contact-headline"
          >
            Ready to Build
            <br />
            <span className="text-outline-cyan">the Future?</span>
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
          className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-12"
        >
          <p
            className="max-w-md text-sm leading-relaxed text-secondary md:text-base lg:col-span-6"
            data-testid="contact-subheadline"
          >
            Whether you have a groundbreaking app idea, an energy project, or
            an industrial manufacturing venture, let's build it together.
          </p>
          <div className="flex items-start lg:col-span-6 lg:justify-end">
            <button
              data-testid="contact-connect-button"
              onClick={() => onContact()}
              className="hud-corners group flex items-center gap-3 border border-neon bg-neon/10 px-10 py-5 font-mono text-xs uppercase tracking-[0.3em] text-neon transition-all duration-300 hover:bg-neon hover:text-[#0B0C10] hover:drop-shadow-[0_0_20px_rgba(0,255,148,0.55)]"
            >
              Connect With Our Team
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;
